;(function ($) {
  "use strict"
  const addressForm = $(".es-address-form")
  const taxPayerCheckbox = $("#id_tax_payer", addressForm)
  const icDphElement = $("#id_billing_ic_dph", addressForm)

  /**
   * @param {boolean} checked - Stav checkbox-u, ktorý vyvolal zmenu
   * @param {string} elementSelector - Selektor pre tú časť formulár ktorá sa má vypnúť alebo zapnúť
   */
  function toggleFormSection(checked, elementSelector) {
    if (checked) {
      $(elementSelector, addressForm).show()
    } else {
      $(elementSelector, addressForm).hide()
    }
  }

  const differentDeliveryAddrCheckbox = $("#id_different_delivery_addr", addressForm)

  toggleFormSection(differentDeliveryAddrCheckbox.prop("checked"), "#tg-delivery-addr-form")

  differentDeliveryAddrCheckbox.change(function () {
    toggleFormSection($(this).prop("checked"), "#tg-delivery-addr-form")
  })

  const companyInvoice = $("#id_company_invoice", addressForm)

  toggleFormSection(companyInvoice.prop("checked"), "#tg-company-form")

  companyInvoice.change(function () {
    toggleFormSection($(this).prop("checked"), "#tg-company-form")
  })

  /**
   * @param {boolean} taxPayer - Určuje, či je zákazník platca DPH alebo nie.
   */
  function toggleBillingIcDph(taxPayer) {
    let vatPrefix

    if (taxPayer) {
      const billing_country_iso_code3 = $("#id_billing_country", addressForm).val()
      if (billing_country_iso_code3 === "SVK") {
        vatPrefix = "SK"
      } else {
        vatPrefix = ""
      }

      icDphElement.val(vatPrefix + $.trim($("#id_billing_dic", addressForm).val()))
      icDphElement.parent().parent().show()
    } else {
      icDphElement.val("")
      icDphElement.parent().parent().hide()
    }
  }

  if (taxPayerCheckbox.prop("checked")) {
    icDphElement.parent().parent().show()
  } else {
    icDphElement.parent().parent().hide()
  }

  taxPayerCheckbox.change(function () {
    toggleBillingIcDph($(this).prop("checked"))
  })
})(jQuery)

/**
 * Na základe toho, ako je nastavená krajina sa nastavuje hodnota pre placeholder a help
 * textu tel. čísla.
 * @param countryInput Input krajiny.
 * @param phoneNumberInput Input tel čísla.
 */
function setPhoneNumberFormGroupBasedOnCountryInput(countryInput, phoneNumberInput) {
  const phoneNumberHelpText = document.createElement("div")
  phoneNumberHelpText.classList.add("help-block")
  phoneNumberInput.insertAdjacentElement("afterend", phoneNumberHelpText)

  function setPhoneNumberPlaceholderAndHelpText() {
    switch (countryInput.value) {
      case "SVK":
        phoneNumberInput.setAttribute("placeholder", "+421905111222")
        phoneNumberHelpText.innerText = "Telefón zadávajte s predvoľbou +421, napr. +421905111222."
        break
      case "CZE":
        phoneNumberInput.setAttribute("placeholder", "+420666111222")
        phoneNumberHelpText.innerText = "Telefón zadávajte s predvoľbou +420, napr. +420666111222."
        break
    }
  }

  setPhoneNumberPlaceholderAndHelpText()

  countryInput.addEventListener("change", setPhoneNumberPlaceholderAndHelpText)
}

onReady(() => {
  const billingCountryInput = document.getElementById("id_billing_country")
  const billingPhoneNumberInput = document.getElementById("id_billing_phone_number")

  if (billingCountryInput && billingPhoneNumberInput) {
    setPhoneNumberFormGroupBasedOnCountryInput(billingCountryInput, billingPhoneNumberInput)
  }

  const deliveryCountryInput = document.getElementById("id_delivery_country")
  const deliveryPhoneNumberInput = document.getElementById("id_delivery_phone_number")

  if (deliveryCountryInput && deliveryPhoneNumberInput) {
    setPhoneNumberFormGroupBasedOnCountryInput(deliveryCountryInput, deliveryPhoneNumberInput)
  }
})
